import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 13 11",
  "content": "<symbol viewBox=\"0 0 13 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\">\n<path d=\"M12.1678 9.71716C12.1678 9.71716 12.1678 3.24366 12.1678 2.60729C12.1678 1.74363 11.3817 1.82457 11.3817 1.82457C11.3817 1.82457 6.68652 1.83012 6.93486 1.82457C6.66545 1.83012 6.53242 1.68377 6.53242 1.68377C6.53242 1.68377 6.34506 1.36225 6.00913 0.853386C5.65658 0.320123 5.24859 0.407697 5.24859 0.407697H1.78844C0.829441 0.407697 0.818359 1.33011 0.818359 1.33011C0.818359 1.33011 0.818359 9.0054 0.818359 9.66949C0.818359 10.6983 1.59553 10.5708 1.59553 10.5708C1.59553 10.5708 10.8673 10.5708 11.4527 10.5708C12.2842 10.5708 12.1678 9.71716 12.1678 9.71716Z\" fill=\"#409EFF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file.svg
// module id = fQ0v
// module chunks = 111